import { Filter } from "./filter";

export class ByRegistered extends Filter {
  constructor(public id?: number) {
    super("by.registered");
  }
}
